// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3J3E-","title":"Info_title__2GRBR","selects":"Info_selects__zY8X8","requiredAsterisk":"Info_requiredAsterisk__zOeKp"};